import { render, staticRenderFns } from "./CelularFormType.vue?vue&type=template&id=ef9d29f6&"
import script from "./CelularFormType.vue?vue&type=script&lang=js&"
export * from "./CelularFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports